/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppAiAgentConfigShowPathParams,
	WhatsAppAiAgentConfigShowResponse,
} from '../types/WhatsAppAiAgentConfigShow'

/**
 * GET /campaigns/:campaignId/whatsapp-ai-config
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::show
 */
export async function whatsAppAiAgentConfigShow(
	campaignId: WhatsAppAiAgentConfigShowPathParams['campaignId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppAiAgentConfigShowResponse>> {
	return axiosInstance.get(`/campaigns/${campaignId}/whatsapp-ai-config`, config)
}
